import type { ShopItemListParams } from '../model/types';

export const SHOP_KEYS = {
  all: ['shop'] as const,
  itemList: (params?: ShopItemListParams) => [...SHOP_KEYS.all, 'item-list', params] as const,
};
